const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/manage/publication_requests/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_cms/cms/manage/publication_requests/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "My Publication Requests",
      description: "Page title for CMS my publication requests list"
    })
  }
});